import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  alertApiRef,
  configApiRef,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
  identityApiRef,
  // storageApiRef,
} from '@backstage/core-plugin-api';
import { toastApiRef } from '@backstage/frontend-plugin-api';
import {
  ScaffolderClient,
  scaffolderApiRef,
} from '@backstage/plugin-scaffolder';
import { mlflowApiRef, MLFlowClient } from '@internal/backstage-plugin-mlflow';
import {
  deploymentApiRef,
  DeploymentClient,
} from '@internal/backstage-plugin-deployment';
import {
  requestTrackerApiRef,
  RequestTrackerClient,
} from '@internal/backstage-plugin-request-tracker';

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  createApiFactory({
    api: mlflowApiRef,
    deps: { discoveryApi: discoveryApiRef, identityApi: identityApiRef, configApi: configApiRef },
    factory: ({ discoveryApi, identityApi, configApi }) =>
      new MLFlowClient({ discoveryApi, identityApi, configApi }),
  }),
  createApiFactory({
    api: deploymentApiRef,
    deps: { discoveryApi: discoveryApiRef, identityApi: identityApiRef },
    factory: ({ discoveryApi, identityApi }) =>
      new DeploymentClient({ discoveryApi, identityApi }),
  }),
  createApiFactory({
    api: requestTrackerApiRef,
    deps: { discoveryApi: discoveryApiRef, identityApi: identityApiRef },
    factory: ({ discoveryApi, identityApi }) =>
      new RequestTrackerClient({ discoveryApi, identityApi }),
  }),
  createApiFactory({
    api: scaffolderApiRef,
    deps: {
      discoveryApi: discoveryApiRef,
      scmIntegrationsApi: scmIntegrationsApiRef,
      fetchApi: fetchApiRef,
      identityApi: identityApiRef,
    },
    factory: ({ discoveryApi, scmIntegrationsApi, fetchApi, identityApi }) =>
      new ScaffolderClient({
        discoveryApi,
        scmIntegrationsApi,
        fetchApi,
        identityApi,
        useLongPollingLogs: true,
      }),
  }),
  // createApiFactory({
  //   api: visitsApiRef,
  //   deps: { storageApi: storageApiRef },
  //   factory: ({ storageApi }) => {
  //     return new DefaultVisitsApi({
  //       storageApi
  //     });
  //   },
  // }),
  // The notifications plugin (>=0.5.x) migrated from AlertApi to the new-frontend
  // ToastApi (apiRef "core.toast"). Our app runs on the legacy frontend system, which
  // registers no core.toast implementation, so NotificationsTable/SideBarItem crash with
  // "No implementation available for apiRef{core.toast}". Bridge it onto the AlertApi.
  createApiFactory({
    api: toastApiRef,
    deps: { alertApi: alertApiRef },
    factory: ({ alertApi }) => {
      const severityFor = (
        status?: 'neutral' | 'info' | 'success' | 'warning' | 'danger',
      ): 'success' | 'info' | 'warning' | 'error' => {
        switch (status) {
          case 'danger':
            return 'error';
          case 'warning':
            return 'warning';
          case 'info':
          case 'neutral':
            return 'info';
          default:
            return 'success';
        }
      };
      return {
        post: toast => {
          const parts = [toast.title, toast.description]
            .filter(Boolean)
            .map(part => (typeof part === 'string' ? part : String(part ?? '')));
          alertApi.post({
            message: parts.join(' — ') || 'Notification',
            severity: severityFor(toast.status),
            display: 'transient',
          });
          return { close: () => {} };
        },
      };
    },
  }),
  ScmAuth.createDefaultApiFactory(),
];
